import { NgModule } from '@angular/core';

import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';
import { SharedModule } from '../../../shared';
import { PedidoReferenciaDataSelectModule } from '../referencia-data';
import { CampanhaMultiselectModule } from '../../campanhas/campanhas/components/multiselect';
import { PacoteCampanhaMultiselectModule } from '../../campanhas/pacotes/components/multiselect';
import { ClassificacaoTipoMultiselectModule } from '../../classificacao/tipo/multiselect';
import { ClienteTipoMultiselectModule } from '../../cliente-tipo/multiselect';
import { ConfigPedidoModule } from '../../configuracoes/app/pedido';
import { ItemLinhaMultiselectModule } from '../../item-linha/multiselect';
import { ItemMarcaMultiselectModule } from '../../item-marca/multiselect';
import { ItemMultiselectModule } from '../../item/multiselect';
import { RepresentanteMultiselectModule } from '../../pessoa/representante/multiselect';
import { TabelaPrecoMultiselectModule } from '../../tabela-preco/multiselect';
import { UnidadeNegocioMultiselectModule } from '../../unidade-negocio/multiselect';
import { PedidoStatusModule } from '../status';
import { PedidoClicheriaStatusMultiselectModule } from '../clicheria/components/multiselect';
import { NovoRepresentanteMultiSelectModule } from '../../../domains/shared/components/novo-representante-multi-select/novo-representante-multi-select.module';
import { NovoAreaMultiselectModule } from '../../../domains/shared/components/novo-area-multiselect/novo-area-multiselect.module';
import { NovoTypeaheadCidadeModule } from '../../../domains/shared/components/novo-typeahead-cidade/novo-typeahead-cidade.module';
import { NovoClassificacaoFaturamentoMultiselectModule } from '../../../domains/shared/components/novo-classificacao-faturamento-multiselect/novo-classificacao-faturamento-multiselect.module';
import { NovoCanalVendaMultiselectModule } from '../../../domains/shared/components/novo-canal-venda-multiselect/novo-canal-venda-multiselect.module';
import { NovoCondicaoPagamentoMultiselectModule } from '../../../domains/shared/components/novo-condicao-pagamento-multiselect/novo-condicao-pagamento-multiselect.module';
import { NovoCondicaoPagamentoTipoMultiselectModule } from '../../../domains/shared/components/novo-condicao-pagamento-tipo-multiselect/novo-condicao-pagamento-tipo-multiselect.module';
import { NovoEstadoMultiselectModule } from '../../../domains/shared/components/novo-estado-multiselect/novo-estado-multiselect.module';
import { NovoFormaPagamentoMultiselectModule } from '../../../domains/shared/components/novo-forma-pagamento-multiselect/novo-forma-pagamento-multiselect.module';
import { NovoLocalFaturamentoMultiselectModule } from '../../../domains/shared/components/novo-local-faturamento-multiselect/novo-local-faturamento-multiselect.module';
import { NovoOperacaoContaOrdemMultiselectModule } from '../../../domains/shared/components/novo-operacao-conta-ordem-multiselect/novo-operacao-conta-ordem-multiselect.module';
import { NovoOperacaoVendaMultiselectModule } from '../../../domains/shared/components/novo-operacao-venda-multiselect/novo-operacao-venda-multiselect.module';
import { NovoPedidoSetorGepMultiselectModule } from '../../../domains/shared/components/novo-pedido-setor-gep-multiselect/novo-pedido-setor-gep-multiselect.module';
import { NovoTypeaheadClientePessoaModule } from '../../../domains/shared/components/novo-typeahead-cliente-pessoa/novo-typeahead-cliente-pessoa.module';
import { NovoCustomerShareIndicadorMultiselectModule } from '../../../domains/shared/components/novo-customer-share-indicador-multiselect/novo-customer-share-indicador-multiselect.module';
import { NovoOrigemLancamentoCadastroMultiselectModule } from '../../../domains/shared/components/novo-origem-lancamento-cadastro-multiselect/novo-origem-lancamento-cadastro-multiselect.module';

import { PedidoFilterComponent } from './pedido-filter.component';

@NgModule({
    imports: [
        SharedModule,
        PedidoReferenciaDataSelectModule,
        PedidoStatusModule,
        ConfigPedidoModule,
        RepresentanteMultiselectModule,
        ClassificacaoTipoMultiselectModule,
        UnidadeNegocioMultiselectModule,
        ItemMarcaMultiselectModule,
        ItemLinhaMultiselectModule,
        TabelaPrecoMultiselectModule,
        ClienteTipoMultiselectModule,
        ItemMultiselectModule,
        MultiselectDropdownModule,
        PacoteCampanhaMultiselectModule,
        CampanhaMultiselectModule,
        NgxBootstrapMultiselectModule,
        PedidoClicheriaStatusMultiselectModule,
        NovoRepresentanteMultiSelectModule,
        NovoAreaMultiselectModule,
        NovoTypeaheadCidadeModule,
        NovoClassificacaoFaturamentoMultiselectModule,
        NovoCanalVendaMultiselectModule,
        NovoCondicaoPagamentoMultiselectModule,
        NovoCondicaoPagamentoTipoMultiselectModule,
        NovoEstadoMultiselectModule,
        NovoFormaPagamentoMultiselectModule,
        NovoLocalFaturamentoMultiselectModule,
        NovoOperacaoContaOrdemMultiselectModule,
        NovoOperacaoVendaMultiselectModule,
        NovoPedidoSetorGepMultiselectModule,
        NovoTypeaheadClientePessoaModule,
        NovoCustomerShareIndicadorMultiselectModule,
        NovoOrigemLancamentoCadastroMultiselectModule,
    ],
    declarations: [
        PedidoFilterComponent
    ],
    exports: [
        PedidoFilterComponent
    ]
})
export class PedidoFilterModule { }
